import { QRCodeSVG } from 'qrcode.react';

export function QRPage2() {
  // Obtener la URL base del sitio
  const baseUrl = window.location.origin;
  const linkTreeUrl = `${baseUrl}/links2`;

  const handleDownload = () => {
    const svg = document.getElementById('qr-code-2');
    if (!svg) return;

    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    canvas.width = 300;
    canvas.height = 300;

    img.onload = () => {
      ctx?.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.download = 'QR-Code-Links2.png';
      downloadLink.href = pngFile;
      downloadLink.click();
    };

    img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-orange-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-[#0052A3] mb-2">
            Generador de QR - Links 2
          </h1>
          <p className="text-gray-600">
            Página administrativa para generar el código QR de la segunda página de links
          </p>
        </div>

        {/* QR Generator inline */}
        <div className="flex flex-col items-center gap-4 p-8 bg-white rounded-lg shadow-xl">
          <h2 className="text-2xl font-bold text-[#0052A3]">Código QR - Links 2</h2>
          <div className="p-4 bg-white rounded-lg border-4 border-[#0052A3]">
            <QRCodeSVG
              id="qr-code-2"
              value={linkTreeUrl}
              size={300}
              level="H"
              includeMargin={true}
              bgColor="transparent"
              fgColor="#000000"
            />
          </div>
          <button
            onClick={handleDownload}
            className="px-6 py-3 bg-[#0052A3] text-white font-semibold rounded-lg hover:bg-[#003d7a] transition-colors"
          >
            Descargar QR
          </button>
          <p className="text-sm text-gray-600 text-center max-w-md">
            Escanea este código QR para acceder a los enlaces
          </p>
        </div>

        <div className="mt-8 p-6 bg-white rounded-lg shadow-lg">
          <h3 className="text-xl font-semibold text-[#0052A3] mb-4">
            Información del enlace:
          </h3>
          <div className="space-y-2">
            <div className="flex items-start gap-2">
              <span className="font-semibold text-gray-700">URL:</span>
              <a 
                href={linkTreeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline break-all"
              >
                {linkTreeUrl}
              </a>
            </div>
            <div className="mt-4 p-4 bg-blue-50 rounded-lg">
              <p className="text-sm text-gray-700">
                <strong>Nota:</strong> Esta página es solo para uso administrativo. 
                El enlace <code className="bg-white px-2 py-1 rounded">/links2</code> no 
                está vinculado en ningún menú del sitio web, solo es accesible mediante 
                el código QR o conociendo la URL directa.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
